




























import { Component, Vue, Watch } from "vue-property-decorator";
interface url {
    link: string;
    owner: string;
    checked: boolean;
    isCustom?: boolean;
}
@Component({})
export default class UrlController extends Vue {
    right: number = -525;
    opacity: number = 0.2;

    urls: Array<url> = [
        {
            link: "https://fctest.hongfund.com:8501/api/",
            owner: "集成环境",
            get checked() {
                return this.link === Vue.axios.defaults.baseURL;
            }
        },
        {
            link: "https://fc.hongfund.com:8601/api/",
            owner: "生产环境",
            get checked() {
                return this.link === Vue.axios.defaults.baseURL;
            }
        },
        {
            link: "https://fc.hongfund.com:8602/api/",
            owner: "金账师",
            get checked() {
                return this.link === Vue.axios.defaults.baseURL;
            }
        },
        {
            link: "https://fc.hongfund.com:8602/api/",
            owner: "金账师2",
            get checked() {
                return this.link === Vue.axios.defaults.baseURL;
            }
        },
        {
            link: "http://localhost:8088/api/",
            owner: "本地",
            get checked() {
                return this.link === Vue.axios.defaults.baseURL;
            }
        },
        {
            link: localStorage.getItem("customUrl") === null ? "" : <string>localStorage.getItem("customUrl"),
            owner: "自定义",
            get checked() {
                return this.link === Vue.axios.defaults.baseURL;
            },
            isCustom: true
        }
    ]

    get showMain() {
        return this.right === 0
    }

    toggleBar() {
        if (this.showMain) {
            this.right = -525;
        } else {
            this.right = 0;
        }
    }

    async changeUrl(on: boolean, url: url) {
        setTimeout(this.toggleBar, 500);
        if (!url.isCustom) {
            Vue.axios.defaults.baseURL = url.link;
            localStorage.setItem("customUrl", url.link);
        } else {
            let data = await this.$prompt("请输入自定义地址", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputValue: <string>localStorage.getItem("customUrl")
            });
            // @ts-ignore
            let val: string = data.value;
            localStorage.setItem("customUrl", val);
            Vue.axios.defaults.baseURL = val;
            this.urls[this.urls.length - 1].checked = true;
        }
        if (this.$route.path != "/accountbooklist") this.$router.push("/accountbooklist");
        else this.$router.push("/dashboard");        
    }
}
